<template>
  <ModalLogin v-show="!isLogin" @isLogin="handlerLogin"/>

  <main 
    v-show="isLogin"
    @contextmenu.prevent
    @copy.prevent
    @mousedown.prevent
    @selectstart.prevent
    @dragstart.prevent
    class="bg-orange-100 bg-cover bg-no-repeat bg-[url('../image/patrick-fore.jpg')]"
  >
    <div class="h-screen w-screen max-h-screen flex flex-col items-center">
      <div class="container border-gray shadow rounded-lg my-6 p-6 max-h-screen bg-white bg-cover bg-no-repeat bg-[url('../image/wooden-floor-background.jpg')]">
        <div class="flex flex-col items-center mb-4">
          <img src="@/assets/image/cover.png" alt="foto" :style="{'max-height': '200px'}">
        </div>
        <div class="flex flex-col items-center mb-4">
          <h1 class="text-xl font-bold">Happy Birthday</h1>
          <h1 class="text-4xl font-bold">Hikari</h1>
        </div>
        <div class="flex flex-col items-center mb-4 overflow-auto leading-7" :style="{'max-height': '21rem'}">
          <p class="text-justify pr-3 mb-3">
            Hallo, apa kabar? semoga harimu menyenangkan hari ini hehe. Jika kamu membaca pesan ini artinya ulang tahun kamu sudah berlalu beberapa hari lalu, maaf kalau saya baru ngucapin sekarang. Selamat Ulang Tahun Hika. Semoga ditahun ini kamu diberikan kesehatan, diberikan rezeki yang berlimpah, diberikan kelancaran terhadap apa yang kamu cita citakan selama ini, selalu didekatkan dengan teman teman yang baik sama kamu, dan menjadi manusia yang berguna untuk keluarga dan negara.
          </p>
          <p class="text-justify pr-3 mb-3">
            Mungkin kamu bertanya kenapa saya harus membuat ini? Anggap saja pesan ini ada sebagai balasan atas surat aneh dari dirimu yang dulu pernah kau berikan kepada saya, hanya saja kali ini dalam versi yang sedikit berbeda. Saya harap kamu mau membacanya hingga akhir dari isi pesan ini, karena isinya cukup panjang, jadi perlu waktu senggang untuk membacanya hehe.  
          </p>
          <p class="text-justify pr-3 mb-3">
            Mengenal dirimu adalah hal yang cukup berkesan dalam hidup saya, berawal dari kita bertemu ditempat kerja, lalu pernah satu team kerja selama 13 hari, hingga pada akhirnya berjalannya dengan waktu kita menjadi sahabat dekat. Apalagi selama tahun 2024 ini keakraban kita semakin dekat, banyak moment yang kita jalani bersama, Bagiku ini terjadi tidak secara kebetulan, namun karena takdir yang mempertemukan kita. Mungkin dirimu sudah tau perasaan saya pada dirimu, karena kita juga sudah membahasnya sebelumnya, saya akan sedikit mengulang cerita kita yang kemarin, dari awal hingga akihirnya saya memutuskan untuk mengenal dirimu lebih jauh lagi. Karena ada hal yang mungkin tidak saya ceritakan kepada kamu dan saya akan ceritakan disini.  
          </p>
          <p class="text-justify pr-3 mb-3">
            Salah satu alasan dari awal pertemanan kita adalah karena saya jatuh cinta pada dirimu, tepatnya di hari ke 11 dari 13 hari perjalanan dinas, saya pun juga nggak menyangka kenapa hal ini bisa terjadi, sebab saya sendiri termasuk orang yang sulit jatuh cinta kepada wanita, dan bagi saya dirimu adalah wanita ke 3 yang pernah saya cintai selama hidup saya. Mungkin disaat itu saya galau kebingungan, perasaan berubah menjadi gelisah dan jantung terasa berdebar sangat cepat, membuat saya nggak tau harus bagaimana, hal ini hanya terjadi jika saya jatuh cinta kepada seseorang, memang cukup aneh. Setelah balik dari dinas disitulah awal kedekatan saya pada dirimu, dari yang kita jalan berdua, lalu kau perkenalkan Chan dan bita, hingga akhirnya kita membentuk group pertama kita. selama itu saya memang menahan perasaan saya untuk tidak diungkapkan kepada dirimu, singkat cerita pada akhirnya saya temukan jawabannya di 3 bulan setelahnya, inti dari jawabannya adalah saya tidak bisa mengakhiri apa yang akan saya mulai. barulah sejak itu saya ingin melupakan perasaan cinta saya kepada dirimu.  
          </p>
          <p class="text-justify pr-3 mb-3">
            Awalnya saya mulai terbiasa menyesuaikan perasaan saya untuk bisa melupakan dirimu, namun sejalannya dengan waktu, entah kenapa akhir akhir ini perasaan itu balik lagi kepada saya, mungkin karena faktor keakraban kita yang semakin dekat. ditambah lagi ada moment moment yang memicu perasaan itu balik lagi, seperti pada saat di Prambanan, sewaktu dirimu tidur dibahu ku, didukung oleh cuaca yang gerimis, saya tidak sengaja menyandarkan kepalaku di atas kepalamu, secara tidak langsung aku merasakan perasaan yang hangat dari dirimu, aku mendengar detak jantung mu yang terdengar tenang, seolah memberikan isyarat bahwa ada rasa kepercayaan yang mendalam kepada diriku, saat itu perasaanku merasakan kenyamanan yang luar biasa, namun terasa sangat sakit setelah mengenangnya. Selanjutnya pada malam pergantian tahun baru, ketika kita bersama melihat kembang api yang dilepaskan kelangit, aku diam diam mencuri pandanganmu pada saat kau memandangnya, aku melihat dirimu yang tersenyum bahagia menyaksikan moment indah tersebut, seketika jantungku berdebar kencang dan perasaan ku semakin sakit, hingga aku berfikir harus kah aku membenci dirimu, meskipun saya tau jika itu dilakukan mungkin saya akan merindukan mu.  
          </p>
          <p class="text-justify pr-3 mb-3">
            Sesaat saya berfikir bisa saja saya mencintai seseorang tanpa harus memiliki, tapi setelah dipelajari lagi ternyata hal itu terlalu naif bagi saya, saya hanya akan jadi manusia yang egois tentang cinta, seseorang yang hanya bisa memberikan banyak harapan palsu, dan pada akhirnya saya hanya akan melukai perasaanmu nantinya. Saya meminta maaf atas kesalahan dan kegaduhan kecil yang saya perbuat karena saya mencintai anda, jadi mungkin udah tiba waktunya untuk menebus kesalahan saya, saya izin pamit untuk tidak menemui kamu dulu sampai dengan saya bisa melupakan perasaan cinta saya sepenuhnya, saya harap ini tidak lama dan hanya sementara, kepergian saya bukan karena ingin membenci dirimu, tapi hanya ingin menghilangkan rasa cinta saya kepada dirimu, kamu masih bisa chat sewaktu waktu jika memang diperlukan. sekali lagi saya ucapkan banyak terima kasih sama kamu untuk semua kenangan kenangan indah selama 2024 serta tahun tahun sebelumnya, mungkin ini akan jadi kenangan yang sulit dilupakan. jaga dirimu baik baik, tetap menjadi orang baik dan tetaplah berteman dengan orang yang baik. sekali lagi saya mau ngucapkan terima kasih, dan saya akhiri dengan sayonara :)
          </p>
        </div>
      </div>

      <AudioPlayer ref="audio"/>
    </div>
  </main>
</template>

<script>
import AudioPlayer from '@/components/AudioPlayer.vue';
import ModalLogin from '@/components/ModalLogin.vue';

export default {
  name: 'HomeView',
  data() {
    return {
      isLogin: false,
    };
  },
  components: {
    AudioPlayer,
    ModalLogin
  },
  methods: {
    handlerLogin(data) {
      this.isLogin = data;
      document.title = 'That one person like you!';
      this.$refs.audio.playAudio();
    }
  },
  mounted() {
    document.title = "Verify it's you!";
  }
}
</script>

<style>
.container {
  width: calc(100vw - 50%);
}

/** lg */
@media (max-width: 1024px) {
  .container {
    width: calc(100vw - 35%);
  }
}

/** md */
@media (max-width: 768px) {
  .container {
    width: calc(100vw - 3rem);
  }
}
</style>